export const ValidationMessages = {
	EmailExist: "Email already in use",
	NotAllowedEmail: "Email is not allowed",
	InvalidEmail: "Email is Invalid",
	InvalidUsername: "Invalid username",
	InvalidPassword: "Invalid password",
	InvalidCode: "Code is Invalid",
	AddressNotVerified: "The address is not verified",
};
